<script>
// TODO User Profile addressess Crud
import { authComputed } from '@/state/helpers'
import { required, email } from 'vuelidate/lib/validators'
import api from '@/helpers/api'
import tableMixin from '@/mixins/table'
export default {
  name: 'account.profile.addresses',
  data: () => ({
    addresses: [],
    isLoading: false,
    search: null,
    showForm: false,
    currentAddress: null,
    selectedAddressId: null,
    fields: [
      {
        key: 'company_name',
        label: 'Company Name',
        thStyle: { width: '280px' }
      },
      {
        key: 'address',
        label: 'Address'
      },
      {
        key: 'action',
        label: '',
        thStyle: { width: '100px' }
      }
    ]
  }),
  mixins: [tableMixin],
  computed: {
    ...authComputed
  },
  created () {
    this.onRefresh()
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh'
  },
  methods: {
    async onArchive (address) {
      if (address.is_default) {
        this.$bvModal.msgBoxOk('Cannot Archive the default address', {
          title: 'Archive',
          size: 'sm',
          centered: true
        })
        return
      }
      let ok = await this.$bvModal.msgBoxConfirm(
        'The address will be archived. Are you sure?',
        {
          title: 'Confirm Archive',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      if (!ok) return
      await api.addresses.update({
        id: address.id,
        is_archived: true
      })
      this.$bvToast.toast(`Address was archived!`, {
        title: 'Address archived',
        solid: true,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        autoHideDelay: 1000,
        appendToast: true
      })
      await this.onRefresh()
    },
    async onUnArchive (address) {
      await api.addresses.update({
        id: address.id,
        is_archived: false
      })
      this.$bvToast.toast(`Address was unarchived!`, {
        title: 'Address unarchived',
        solid: true,
        toaster: 'b-toaster-top-center',
        variant: 'success',
        autoHideDelay: 1000,
        appendToast: true
      })
      await this.onRefresh()
    },
    onEdit (item) {
      this.showForm = true
      this.currentAddress = item
      this.selectedAddressId = item.id
    },
    async onSave (address) {
      if (this.selectedAddressId) {
        if (address.is_default) {
          await api.addresses.updateAll({
            is_default: false,
            where: {
              is_default: { _eq: true }
            }
          })
        }
        await api.addresses.update({
          ...address
        })
        this.selectedAddressId = null
      } else {
        if (address.is_default) {
          await api.addresses.updateAll({
            is_default: false,
            where: {
              is_default: { _eq: true }
            }
          })
        }
        await api.addresses.create({
          ...address,
          is_shipping_address: true
        })
      }

      this.onRefresh()
    },
    async onRefresh () {
      this.isLoading = true
      let filters = [
        { is_shipping_address: { _eq: true } },
        { is_archived: { _eq: false } }
      ]
      if (this.search) filters = [{ is_shipping_address: { _eq: true } }]

      let { items, total_rows } = await api.addresses.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        filters,
        needle: this.search
      })
      this.data = items
      this.totalRows = total_rows
      this.isLoading = false
    }
  }
}
</script>
<template>
  <b-card>
    <g-overlay :show="isLoading">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex m-0 align-items-center">
          <h4 class="font-weight-light mb-0">
            <i class="bx bx-map mr-1"></i>Addresses
          </h4>
          <b-btn
            class="mx-3"
            variant="outline-primary"
            size="sm"
            v-on:click="showForm = true"
          >
            <i class="bx bx-plus mr-1"></i>New
          </b-btn>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <g-search-input
            v-model="search"
            placeholder="Find Addresses"
            width="300px"
            class="mr-0 ml-2 m-0"
          />
        </div>
      </div>
      <b-row no-gutters>
        <b-table
          show-empty
          hover
          :items="data"
          :fields="fields"
          :busy="isLoading"
          head-variant="white"
          stacked="md"
          tbody-tr-class="pointer"
        >
          <template v-slot:cell(company_name)="{ item }">
            {{ item.company_name }}
            <i class="mdi mdi-star ml-1 mb-4" v-if="item.is_default"></i>
          </template>
          <template v-slot:cell(address)="{ item }">
            {{ item.street }} {{ item.number }},<br />
            {{ item.zipcode }} {{ item.city }} ({{ item.country_name }})
          </template>
          <template v-slot:cell(action)="{ item }">
            <div class="d-flex">
              <b-btn variant="link" v-on:click="onEdit(item)">
                <i class="far fa-edit"></i>
              </b-btn>
              <b-btn
                variant="link"
                v-on:click="onArchive(item)"
                v-if="!item.is_archived"
              >
                <i
                  class="mdi mdi-archive-arrow-down-outline text-danger font-size-16"
                ></i>
              </b-btn>
              <b-btn variant="link" v-on:click="onUnArchive(item)" v-else>
                <i
                  class="mdi mdi-archive-arrow-up text-danger font-size-16"
                ></i>
              </b-btn>
            </div>
          </template>
        </b-table>
      </b-row>

      <div class="d-flex align-items-center justify-content-between p-0 mt-2">
        <div class="dataTables_length" v-if="totalRows > minPerPage">
          <label class="d-flex align-items-center m-0">
            Show
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-2"
            ></b-form-select>
          </label>
        </div>

        <b-pagination
          v-if="perPage !== 'All' && totalRows > perPage"
          class="pagination mb-0 justify-content-end"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        >
          <template v-slot:page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>
      <app-address-form-dialog
        :address-id="selectedAddressId"
        :visible.sync="showForm"
        v-on:created="onSave"
      />
    </g-overlay>
  </b-card>
</template>
